angular.module('eStories.sortFilter.model', [

    /*eStories sorting filters*/

])
    .service('SortFilterModel', [function () {
        var model = this;

    }])
    .factory('SortFilterFactory', ['$location', function ($location) {
        return {

            listViewMode: {
                'eStories.navbars.author': {mode: true},
                'eStories.navbars.authorFull': {mode: true},
                'eStories.navbars.narrator': {mode: true},
                'eStories.navbars.narratorFull': {mode: true},
                'eStories.navbars.publisher': {mode: true},
                'eStories.navbars.publisherFull': {mode: true},
                'eStories.navbars.browse': {mode: false},
                'eStories.navbars.browseGenre': {mode: false},
                'eStories.navbars.library': {mode: true},
                'eStories.navbars.wishList': {mode: true},
                'eStories.navbars.seeAll': {mode: true}
            },

            updateFilter: false,

            filterObj: {
                genreId: null,
                subGenreId: null,
                languageId: null,
                sortField: null,
                duration: null,
                abridged: null,
                onlyForCredit: null,
                onlyForFree: null,
                onlyOnSale: null
            },

            seeAllFilterObj: {
                genreId: null,
                subGenreId: null,
                languageId: null,
                sortField: null,
                duration: null,
                abridged: null,
                sectionId: null
            },

            libraryFilterObj: {
                pageNumberNumber: null,
                sortField: null
            },

            resetFilterObj: function (callbackFunc) {
                this.filterObj = {
                    genreId: null,
                    subGenreId: null,
                    languageId: null,
                    sortField: null,
                    duration: null,
                    abridged: null,
                    onlyForCredit: null,
                    onlyForFree: null,
                    onlyOnSale: null
                }
                if(callbackFunc != null) {
                    callbackFunc()
                }
            },

            getSortListOptions: function (currentState) {
                switch (currentState) {
                    case 'eStories.navbars.browse':
                        return this.CatalogSortOptionList;
                        break;
                    case 'eStories.navbars.browseGenre':
                        return this.CatalogSortOptionList;
                        break;
                    case 'eStories.navbars.seeAll':
                        return this.SeeAllSortOptionList;
                        break;
                    case 'eStories.navbars.author':
                    case 'eStories.navbars.authorFull':
                        return this.CatalogSortOptionList;
                        break;
                    case 'eStories.navbars.publisher':
                    case 'eStories.navbars.publisherFull':
                        return this.CatalogSortOptionList;
                        break;
                    case 'eStories.navbars.narrator':
                    case 'eStories.navbars.narratorFull':
                        return this.CatalogSortOptionList;
                        break;
                    case 'eStories.navbars.wishList':
                        return this.WishlistSortOptionList;
                        break;
                    case 'eStories.navbars.library':
                        return this.LibrarySortOptionList;
                        break;
                    default:
                        if ($location.path() == '/sort/library') {
                            return this.LibrarySortOptionList;
                        } else if ($location.path() == '/sort/wishlist') {
                            return this.WishlistSortOptionList;
                        }
                }
            },

            topLevelGenres: null,
            availableLanguages: null,

            cachedSubGenres: {},

            durationList: [
                {
                    name: 'Under 1 Hour',
                    minHours: null,
                    maxHours: 1,
                    id: '0-1'
                },    //under 1 hour
                {
                    name: '1-3 Hours',
                    minHours: 1,
                    maxHours: 3,
                    id: '1-3'
                },   //1-3 hours
                {
                    name: '3-6 Hours',
                    minHours: 3,
                    maxHours: 6,
                    id: '3-6'
                },   // 3-6 hours
                {
                    name: '6-10 Hours',
                    minHours: 6,
                    maxHours: 10,
                    id: '6-10'
                },  //6-10 hours
                {
                    name: '10-20 Hours',
                    minHours: 10,
                    maxHours: 20,
                    id: '10-20'
                }, //10-20 hours
                {
                    name: 'Over 20 Hours',
                    minHours: 20,
                    maxHours: null,
                    id: '20-'
                }    //over 20 hours
            ],

            LibrarySortOptionList: [
                {
                  name: 'Recently Played',
                  value: 'RECENTLY_PLAYED'
                },
                {
                    name: 'Title',
                    value: 'TITLE'
                },
                {
                    name: 'Date Added',
                    value: 'DATE_ADDED'
                },
                {
                    name: 'Duration',
                    value: 'DURATION'
                },
                {
                    name: 'Rating',
                    value: 'RATING'
                },
                {
                    name: 'Review Date',
                    value: 'REVIEW_DATE'
                }

            ],

            WishlistSortOptionList: [
                {
                    name: 'Title',
                    value: 'TITLE'
                },
                {
                    name: 'Date Added',
                    value: 'DATE_ADDED'
                },
                {
                    name: 'Price',
                    value: 'PRICE'
                }
            ],

            SeeAllSortOptionList: [
                {
                    name: 'Alphabetically A-Z',
                    value: 'ALPHABETICALLY'
                },
                {
                    name: 'Most Popular',
                    value: 'MOST_POPULAR'
                },
                {
                    name: 'Most Popular (Week)',
                    value: 'MOST_POPULAR_THIS_WEEK'
                },
                {
                    name: 'Most Popular (Month)',
                    value: 'MOST_POPULAR_THIS_MONTH'
                },
                {
                    name: 'Release Date',
                    value: 'RELEASE_DATE'
                },
                {
                    name: 'Highest Rated',
                    value: 'HIGHEST_RATED'
                }
            ],


            CatalogSortOptionList: [
                {
                    name: 'Alphabetically A-Z',
                    value: 'ALPHABETICALLY'
                },
                {
                    name: 'Most Popular',
                    value: 'MOST_POPULAR'
                },
                {
                    name: 'Most Popular (Week)',
                    value: 'MOST_POPULAR_THIS_WEEK'
                },
                {
                    name: 'Most Popular (Month)',
                    value: 'MOST_POPULAR_THIS_MONTH'
                },
                {
                    name: 'Release Date',
                    value: 'RELEASE_DATE'
                },
                {
                    name: 'Highest Rated',
                    value: 'HIGHEST_RATED'
                }

            ],

            formatList: [
                {name: 'Abridged', value: true},
                {name: 'Unabridged', value: false}
            ],
            priceTypeList: [
                {name: 'onlyForFree', value: true, label: 'Free Audiobooks', mobileLabel: "Free"},
                {name: 'onlyForCredit', value: true, label: 'For Credit', mobileLabel: "For Credit"},
                {name: 'onlyOnSale', value: true, label: 'On Sale', mobileLabel: "On Sale"}
            ]

        }
    }]);

